import { getJsonOrError } from '../../../jsCore/utils/fetch'
import { queryString } from '../../../jsCore/utils/window'
import { info } from '../../../jsCore/application/console'

const featureFlags = {
  debug: queryString.debugRecommendedVideos,
}

function warn(...args) {
  featureFlags.debug && info('[recommended videos]', ...args)
}

const dataProviders = {
  jw({ providerName, playlistId, videoId }) {
    return getJsonOrError(
      `https://cdn.jwplayer.com/v2/playlists/${playlistId}?related_media_id=${videoId}&page_limit=5`
    ).then(data => {
      warn({ providerName, data })
      return data
    })
  },
  yt(providerConf) {
    return 'provider: youtube'
  },
}

function mapOverRecommendedPlaylist(item, idx) {
  return {
    id: idx,
    title: item.title,
    mediaId: item.mediaid,
    description: item.description || 'no description',
    image: item.image,
    hlink: item.link,
  }
}

function parseRecommendedData(data) {
  return data && data.playlist && data.playlist.map(mapOverRecommendedPlaylist)
}

export function getDataByProvider(providerConf) {
  switch (providerConf.providerName) {
    case 'jw':
      return dataProviders.jw(providerConf).then(parseRecommendedData)
    case 'yt':
      return dataProviders.yt(providerConf).then(parseRecommendedData)
    default:
      return warn('no provider configuration was supplied to recommendatioList')
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedVideos/recommendedVideos.providers.js